import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RetailPlaceService } from '../../../core/services/retail-place.service';
import { ModalService } from '../../../core/modal/modal.service';
import { RemoveRetailPlaceComponent } from '../remove-retail-place/remove-retail-place.component';
import { PageHeaderDropdownItem } from '../../../shared/page-header/page-header.model';
import { RetailPlacesApiService } from '../../../core/modules/retail-places/retail-places-api.service';

@Component({
  selector: 'tax-retail-place-settings',
  templateUrl: './retail-place-settings.component.html',
  styleUrls: ['./retail-place-settings.component.sass'],
})

export class RetailPlaceSettingsComponent implements OnInit, OnDestroy {
  readonly dropdownItems: PageHeaderDropdownItem[] = [
    {
      action: () => {
        this.router.navigate([`main/kkms/retailPlace/${this.retailPlace.id}/edit`]);
      },
      icon: 'edit',
      title: 'organization.edit',
    },
    {
      action: () => {
        this.router.navigate([`main/kkms/add-vpn/${this.retailPlace.id}`]);
      },
      icon: 'repeat',
      title: 'retailPlace.vpn.connect',
    },
    {
      action: () => {
        this.modalService.openOld(RemoveRetailPlaceComponent, {
          retailPlaceId: this.retailPlace.id,
        });
      },
      icon: 'delete',
      title: 'retailPlace.remove',
    },
  ];

  private subscription: Subscription[] = [];
  retailPlace: any = {
    title: '',
  };

  retailPlaceTitle: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalService: ModalService,
    private retailPlaceService: RetailPlaceService,
    private retailPlaceApiService: RetailPlacesApiService,
  ) { }

  ngOnInit(): void {
    const retailPlaceId = this.activatedRoute.snapshot.paramMap.get('id');
    this.subscription.push(this.retailPlaceApiService.fetchRetailPlace(Number(retailPlaceId)).subscribe(
      response => this.retailPlace = response,
      () => {},
      () => this.retailPlaceTitle = this.retailPlace.title,
    ));
  }

  isTitleSame(): boolean {
    return this.retailPlace.title === this.retailPlaceTitle;
  }

  goToRetailPlace(): void {
    this.router.navigate(['main/kkms/retailPlace', this.retailPlace.id]);
  }

  submit(): void {
    this.subscription.push(this.retailPlaceService.setNewTitle(this.retailPlace.id, this.retailPlace.title).subscribe(
      (response) => {},
      () => {},
      () => this.retailPlaceTitle = this.retailPlace.title,
    ));
  }

  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
